import { createGlobalState } from "react-hooks-global-state";

const { setGlobalState, useGlobalState } = createGlobalState({
  price: "",
  offerPrice: "",
  suggestPlanPrice: "",
  isValidCouponCode: false,
  couponCode: "",
  selectedPlanId: "",
  ogPlanId: "",
  suggestedPlanId: "",
  showConfetti: false,
  suggestionPlanData: [],
  selectedPlanData: [],
  couponAfterSuccessMessage: "",
  leadSquaredDataVal: {},
  PAYMENTBASEURL: "",
  ALLOWUSERSCRIPTURL: "",
  PRODUCTMAINURL: "",
  VERIFYUSERS: "",
  AUTHORIZEREQURL: "",
  SUBSCRIPTIONSTATUSCHECK: "",
  SECRETSETTLEMENTURL: "",
  CENTRALLOGGERURL: "",
  LINKTRACKERURL: "",
  BASEURL: ""
});

export { useGlobalState, setGlobalState };
